import { render, staticRenderFns } from "./TheMyFavoritesMoreInfoPanel.vue?vue&type=template&id=38384d6e&scoped=true"
import script from "./TheMyFavoritesMoreInfoPanel.vue?vue&type=script&lang=js"
export * from "./TheMyFavoritesMoreInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./TheMyFavoritesMoreInfoPanel.vue?vue&type=style&index=0&id=38384d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38384d6e",
  null
  
)

export default component.exports